<template>
  <loader :task="task" v-slot="{ loading }">
    <slot v-bind="{ loading }" />
  </loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { QueryResult, ReportFilters } from '@/type';
import { HasTaskMixin } from '@/mixins';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './report-repository';

interface Data {
  task: Promise<QueryResult>|undefined,
}

export default defineComponent({
  emits: ['loading', 'update:result'],
  mixins: [HasTaskMixin],
  components: {
    Loader,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    filters: Object as () => ReportFilters,
    result: Object as () => QueryResult,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    load() {
      this.$emit('loading', true);
      this.task = repository.findAll(this.clientId, this.filters);
      this.task.then((result) => {
        this.$emit('update:result', result);
      });
      this.task.finally(() => {
        this.$emit('loading', false);
      });
    },
  },
});
</script>
